import formatDateRange from 'helpers/formatDateRange'

type DiscountDescriptionProps = {
  short?: boolean
  discount: {
    name?: string
    percentage: number
    startDate: string
    endDate: string
  }
}

export default function DiscountDescription({
  short = false,
  discount,
}: DiscountDescriptionProps) {
  const { startDate, endDate } = discount
  const dateRange = formatDateRange(startDate, endDate)

  if (short) {
    return (
      <>
        Get {discount.percentage}% off the nightly price for stays between{' '}
        {dateRange}
      </>
    )
  }

  return (
    <>
      <strong>{discount.name}</strong> Get {discount.percentage}% off the
      nightly price between {dateRange}.
    </>
  )
}
